import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SentenceElementObjekt = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 14),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 1.5,
    strokeWidth: "8",
    children: /*#__PURE__*/jsx("path", {
      d: "m65.2 9.503 34.682 69.365H30.517L65.2 9.503Z",
      transform: "translate(-18.95 .583) scale(1.05155)"
    })
  });
};

export { SentenceElementObjekt };
//# sourceMappingURL=sentence-element.objekt.js.map
